<template>
    <div>
        <Header>
            <Heading1>The Macher Terms of Service ("Agreement")</Heading1>
        </Header>
        <Content>
            <RenderBody :dataList="bodyData"></RenderBody>
        </Content>
    </div>
</template>
<script>
// Data
import body from '~/content/terms/data.json'

// Components
import Header from '../components/base/Header.vue';
import Heading1 from '../components/base/Heading1.vue';
import Paragraph from '../components/base/Paragraph.vue';
import Content from '../components/base/Content.vue';
import RenderBody from '../components/base/RenderBody.vue';

export default {
    components: {
        Header,
        Heading1,
        Paragraph,
        Content,
        RenderBody
    },
    data: function () {
        return {
            head: {
                title: "Terms and Conditions",
                description: `Please read these Terms of Service completely.
This Agreement documents the legally binding terms and conditions attached to the use of the Site at macherusa.com.
By using or accessing the Site in any way, viewing or browsing the Site, or adding your own content to the Site, you are agreeing to be bound by these Terms of Service.
`
            },
            bodyData: body
        };
    },
    head() {
        const { path = "" } = this.$route;

        const metaTitle = this.head.title + " | Macher Jobs";
        const metaDescription = this.head.description
        const canonical = process.env.baseUrl + path;

        return {
            title: metaTitle,
            link: [{ rel: "canonical", href: canonical }],
            meta: this.createMetaTags({
                description: metaDescription,
                title: metaTitle,
                canonical,
                socialTitle: metaTitle,
                socialDescription: metaDescription,
                siteName: "Macher Jobs",
                twitter: "@FrumJewishJobs",
            }),
        };
    },
};
</script>
